import React from "react";
import ThanksSection from "../Yaaaga/ThanksSection/Main";
import DeploymentsSection from "./DeploymentsSection/Main";
import TopSection from "./TopSection/Main";

const OrderForge = () => {
  return (
    <>
      <TopSection />
      <DeploymentsSection />
      <ThanksSection />
    </>
  );
};

export default OrderForge;
